// Format any FastAPI error detail (string, list of Pydantic errors, or object) into a toast-friendly string.
export function formatApiError(err) {
  if (!err) return 'Something went wrong. Please try again.';
  const detail = err?.response?.data?.detail ?? err?.detail ?? err?.message ?? err;
  return formatDetail(detail);
}

export function formatDetail(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => {
        if (e && typeof e === 'object') {
          const loc = Array.isArray(e.loc) ? e.loc.filter(x => x !== 'body').join('.') : '';
          const msg = typeof e.msg === 'string' ? e.msg : JSON.stringify(e);
          return loc ? `${loc}: ${msg}` : msg;
        }
        return String(e);
      })
      .filter(Boolean)
      .join('; ');
  }
  if (typeof detail === 'object' && typeof detail.msg === 'string') return detail.msg;
  return JSON.stringify(detail);
}
